
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Ugrás a nyitólapra',


	'widgetsListLabel': 'Eszközelemek lista. Válasszon ki egy eszközelemet, majd nyomja le az Enter billentyűt a hozzáadáshoz.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Naprakész',
	'dirty': 'Nem naprakész',
	'conflict': 'Ütközés a nézet mentése során',
	'error': 'Probléma a nézet mentése során',
	'failure': 'Nem lehet csatlakozni a szerverhez',
	'saveFailed': 'A nézet nem menthető',

	'wa_insync': 'Mentett',
	'wa_conflict': 'Ütközés a nézet mentése során',
	'wa_error': 'A nézet nem menthető',
	'wa_failure': 'Nem lehet csatlakozni a szerverhez',

	// Menu Labels
	'changeDisplay': 'Megjelenítés módosítása',
	'changeToColumnChart': 'Váltás oszlopdiagramra',
	'changeToBubbleChart': 'Váltás buborékdiagramra',
	'toggleMoveHandles': 'Áthelyezőpontok váltása',
	'undo': 'Visszavonás',
	'redo': 'Mégis',
	'mode': 'Mód átváltása',

	'untitled': 'Névtelen',
	'remove': 'Eltávolítás',
	'editTitle': 'Cím szerkesztése',
	'edit': 'Szerkesztés',
	'done': 'Kész',

	// Data tray
	'dataTrayHandleOpenLabel': 'Adattálca megnyitása',
	'dataTrayHandleCloseLabel': 'Adattálca bezárása',

	// Dialogs
	'dlg_loading': 'Betöltés...',
	'dlg_ok': 'OK',
	'dlg_create': 'Létrehozás',
	'dlg_cancel': 'Mégse',
	'dlg_close': 'Bezárás',
	'dlg_update': 'Frissítés',
	'dlg_renameBoardTitle': 'Objektum átnevezése',
	'dlg_renameDatasetTitle': 'Adathalmaz átnevezése',
	'dlg_renameSceneTitle': 'Jelenet átnevezése',
	'dlg_NameLabel': 'Név:',
	'dlg_NewNameLabel': 'Új név:',
	'dlg_DefaultNameWithDataSet': '%{name} nézet',
	'dlg_ShareTitle': 'Tartalom megosztása',
	'dlg_UnshareTitle': 'Tartalommegosztás eltávolítása',
	'dlg_ShareUser': 'Felhasználóazonosító:',
	'dlg_NewColumnLabel': 'Új számításnév',

	'dlg_new': 'Új...',
	'dlg_open': 'Megnyitás...',
	'dlg_makeACopy': 'Másolat készítése',
	'dlg_rename': 'Átnevezés...',
	'dlg_moreToCome': 'További műveletek várhatók...',

	'dlg_use': 'Használat',

	'dlg_RelinkDatasetTitle': 'A(z) \'%{datasetName}\' adathalmaz cseréje a következőre ...',

	'open_error': 'Hiba történt a nézet megnyitásakor.',

	// Delete Board
	'del_dialogTitle': 'Törlés megerősítése',
	'del_itemMsg': 'Biztosan törli a következőt: \'%{name}\'?',
	'del_itemsMsg': 'Biztosan töröl %{count} elemet?',
	'del_deleteErr': 'A(z) \'%{name}\' nem törölhető',

	// List Sorting
	'dlg_ascending': 'növekvő',
	'dlg_descending': 'csökkenő',
	'dlg_custom': 'egyéni',
	'dlg_none': 'nincs',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Keresés',

	'searchHint': 'Keresés az összes adat között',
	'clearSearchResult': 'Keresési eredmények törlése',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Kör',
	'shapesHexagon': 'Hatszög',
	'shapesLine': 'Vonal',
	'shapesOctagon': 'Nyolcszög',
	'shapesPentagon': 'Ötszög',
	'shapesSquare': 'Négyzet',
	'shapesTriangle': 'Háromszög',
	'shapesDiamond': 'Rombusz',
	'shapesTitle': 'Alakzat tulajdonságai', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Lekerekített négyzet',
	'shapesStar': 'Csillag',
	'shapesChevron': 'Ék',
	'shapesBadge_ribbon': 'Jelvényszalag',
	'shapesBadge': 'Jelvény',
	'shapesHeart': 'Szív',
	'shapesExclamation': 'Felkiáltójel',
	'shapesTrendingup': 'Népszerű előre',
	'shapesTrendingdown': 'Népszerű hátra',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Személyek',
	'shapesFemale': 'Nő',
	'shapesHappyface': 'Mosolygós arc',
	'shapesMale': 'Férfi',
	'shapesMan': 'Férfi',
	'shapesNeutralface': 'Semleges arc',
	'shapesSadface': 'Szomorú arc',
	'shapesShakehands': 'Kézfogás',
	'shapesThumbsdown': 'Nem tetszik',
	'shapesThumbsup': 'Tetszik',
	'shapesWoman': 'Nő',

	// Weather and places
	'shapesPlacesWeatherCat': 'Helyek & időjárás',
	'shapesCity': 'Város',
	'shapesCloud': 'Felhő',
	'shapesEducation': 'Oktatás',
	'shapesGovernment': 'Kormány',
	'shapesHalfcloud': 'Fél felhő',
	'shapesHouse': 'Ház',
	'shapesMoon': 'Hold',
	'shapesRain': 'Eső',
	'shapesSunny': 'Napsütés',

	//Vehicles
	'shapesVehiclesCat': 'Járművek',
	'shapesAirplane': 'Repülő',
	'shapesCar': 'Autó',
	'shapesShip': 'Hajó',
	'shapesShoppingcart': 'Bevásárlókocsi',
	'shapesTrain': 'Vonat',
	'shapesTruck': 'Kamion',

	//Objects
	'shapesObjectsCat': 'Objektumok',
	'shapesBook': 'Könyv',
	'shapesBriefcase': 'Aktatáska',
	'shapesCalendar': 'Naptár',
	'shapesCheck': 'Pipa',
	'shapesClock': 'Óra',
	'shapesDesktop': 'Számítógép',
	'shapesDocument': 'Dokumentum',

	'shapesFood': 'Étel',
	'shapesGear': 'Fogaskerék',
	'shapesHealth': 'Egészség',

	'shapesIdea': 'Ötlet',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Papírpénz',
	'shapesMoney_coin': 'Fémpénz',
	'shapesPiggybank': 'Malacpersely',
	'shapesStackofpaper': 'Papírköteg',
	'shapesStickynote1': '1. öntapadó jegyzet',
	'shapesStickynote2': '2. öntapadó jegyzet',
	'shapesTarget': 'Cél',
	'shapesTool': 'Szerszám',

	'shapesUmbrella': 'Esernyő',

	'shapesBrain': 'Agy',
	'shapesSkull': 'Koponya',
	'shapesEye': 'Szem',

	// Arrows shapes
	'shapesArrowsCat': 'Nyilak',
	'shapesRightArrow': 'Jobbra nyíl',
	'shapesLeftArrow': 'Balra nyíl',
	'shapesDoubleArrow': 'Dupla nyíl',
	'shapesCurvedArrow': 'Görbe nyíl',

	// Callouts shapes
	'shapesCalloutsCat': 'Szövegbuborékok',
	'shapesRectCallout': 'Szövegbuborék',

	// Images
	'imagesCat': 'Képek',
	'imageWidgetTitle': 'Kép eszközelem',
	'imgUrl': 'Kép URL-címe',
	'noImgSelected': 'Nincs kép kijelölve',
	'enterImgUrl': 'Itt adja meg a kép URL-címét',
	'imgPasteLink': 'Illessze be az URL-címet, majd az Enter lenyomásával mentse.',
	'imgResizeToFit': 'Átméretezés a kép méretének megfelelően',
	'imgHeight': 'Magasság:',
	'imgWidth': 'Szélesség:',
	'imgTransparency': 'Átlátszóság:',
	'imgMissingUrl': 'A kép URL-címe hiányzik.',
	'imgUrlValidationError': 'A kép URL-címe érvénytelen.',
	'imgUrlInvalidDomainError': 'A kép URL olyan tartományra mutat, amelyet nem hagyott jóvá adminisztrátora. Az adminisztrátor által jóváhagyott tartományok: "%{domains}".',

	// line shape
	'propStrokeWidth': 'Vonalvastagság',
	'propStrokeDashArray': 'Vonalstílus',
	'propStrokeSolidline': 'Folyamatos vonal',
	'propStrokeLineCap': 'Vonal végződése',
	'propStrokeLineCapButt': 'Sima',
	'propStrokeLineCapRound': 'Kerekítés',
	'propStrokeLineCapSquare': 'Négyzet',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Lejátszás',
	'dataPlayerValueListLabel': 'Adatlejátszó értékei',
	// Text Widget
	'textWidgetTitle': 'Szöveges felületi elem',
	'textStyle': 'Stílusok',
	'textStyleDescription': 'Előre formázott szövegstílusok',
	'textTitleStyle': 'Cím',
	'textTitleSmallStyle': 'Kis cím',
	'textSubtitleStyle': 'Alcím',
	'textBodyStyle': 'Törzs',
	'textBodySmallStyle': 'Kis törzs',
	'textCaptionStyle': 'Felirat',
	'textQuoteStyle': 'Idézet',
	'textQuoteSmallStyle': 'Kis idézet',
	'textResponsiveStyle': 'Automatikus méretezés',
	'textAutoFontSize': 'Automatikus',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hajszálvonal',
	'textFontFamilySubClassThin': 'Vékony',
	'textFontFamilySubClassThinItalic': 'Vékony dőlt',
	'textFontFamilySubClassExtraLight': 'Extra könnyű',
	'textFontFamilySubClassExtraLightItalic': 'Extra könnyű dőlt',
	'textFontFamilySubClassLight': 'Egyszerű',
	'textFontFamilySubClassLightItalic': 'Könnyű dőlt',
	'textFontFamilySubClassRegular': 'Normál',
	'textFontFamilySubClassRegularItalic': 'Normál dőlt',
	'textFontFamilySubClassItalic': 'Dőlt',
	'textFontFamilySubClassMedium': 'Közepes',
	'textFontFamilySubClassMediumItalic': 'Közepes dőlt',
	'textFontFamilySubClassHeavy': 'Nehéz',
	'textFontFamilySubClassHeavyItalic': 'Nehéz dőlt',
	'textFontFamilySubClassDemiBold': 'Középkövér',
	'textFontFamilySubClassDemiBoldItalic': 'Középkövér dőlt',
	'textFontFamilySubClassBold': 'Félkövér',
	'textFontFamilySubClassBoldItalic': 'Kövér dőlt',
	'textFontFamilySubClassExtraBold': 'Extra kövér',
	'textFontFamilySubClassExtraBoldItalic': 'Extra kövér dőlt',
	'textFontFamilySubClassBlack': 'Fekete',
	'textFontFamilySubClassBlackItalic': 'Fekete dőlt',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Automatikus betűméret',
	'responsiveCoachmarkContents': 'A betűméret automatikusan megváltozik az ilyen szövegtípus átméretezésekor. A betűméretet a szöveg tulajdonságaiban állíthatja be.',

	'propText': 'Szöveg részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Szöveg tulajdonságai', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Betűméret',
	'textFontFamily': 'Betűtípuscsalád',
	'textFontWeight': 'Betűvastagság', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Kép hivatkozása',
	'propMissingURL': 'URL megadása',
	'propImgTop': 'Kép tulajdonságai', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Általános tulajdonságok', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Általános', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Általános', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Kitöltés színe', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Szöveg színe', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Szegélyszín',
	'propMaintainAxisScales': 'Tengelylépték megtartása',
	'propShowItemLabel': 'Elemcímke megjelenítése',
	'propHideLegend': 'Jelmagyarázat elrejtése',
	'propColorPalette': 'Paletta',
	'propLegendPosition': 'Jelmagyarázat pozíciója',
	'propHideAxisTitleLabels': 'Tengelycímek elrejtése',
	'propLineColor': 'Vonalszín',
	'propBubbleColor': 'Buborék színe',
	'propInterpolation': 'Simított vonalak',
	'propElementColor': 'Megjelenítési elem színe',
	'propSymbolShape': 'Szimbólum alakzat',
	'propHeatScalePalette': 'Színsorrend',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'A sötétebb színek kisebb értékeket képviselnek.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'A sötétebb színek nagyobb értékeket képviselnek.',
	'propImageDetails': 'Kép részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Weblap részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Médiatartalom részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Adja meg az URL-címet, majd nyomja le az Entert.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Pozíció és stílus',
	'propPositionLabel': 'Pozíció', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Méret', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Szélesség',
	'propResizeHeight': 'Magasság',
	'propRotateLabel': 'Elforgatás',
	'propRotateAngle': 'Szög', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Ikonok mennyisége',
	'propScaleDescription': 'Válassza ki az ikonok mennyiségét',
	'propScaleFew': 'Alsó',
	'propScaleDefault': 'Alapértelmezett',
	'propScaleMany': 'Felső',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Az érték csak numerikus lehet',

	'mediaAriaLabel': 'url-bemenet',
	'dropdownAriaLabel' : 'Legördülő lista',
	'ariaGroupLabel': 'Legördülő lista kategória: %{cateoryLabel} elem: %{itemLabel}. A kibontáshoz nyomja le a LE billentyűt. A FEL és a LE billentyűkkel navigálhat, és az ESCAPE billentyűvel csukhatja össze a listát.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Utolsó frissítés: %{timeInterval} idővel ezelőtt',
	'widgetTimer': 'Eszközelem időmérője',

	// Theme colors
	'transparent': 'Nincs szín',
	'white': 'Fehér',
	'lightGrey': 'Világosszürke',
	'grey': 'Szürke',
	'darkGrey': 'Sötétszürke',
	'black': 'Fekete',
	'lightBlue': 'Világoskék',
	'blue': 'Kék',
	'darkBlue': 'Sötétkék',
	'yellow': 'Sárga',
	'orange': 'Narancssárga',
	'lime': 'Citromzöld',
	'green': 'Zöld',
	'peach': 'Barack',
	'red': 'Piros',
	'violet': 'Lila',
	'aqua': 'Víz',
	'purple': 'Lila',
	'plum': 'szilvakék',
	'gray10': 'Szürke 10',
	'gray20': 'Szürke 20',
	'gray30': 'Szürke 30',
	'gray50': 'Szürke 50',
	'gray60': 'Szürke 60',
	'gray70': 'Szürke 70',
	'gray80': 'Szürke 80',
	'gray90': 'Szürke 90',
	'gray100': 'Szürke 100',
	'blue50': 'Kék 50',
	'blue60': 'Kék 60',
	'blue70': 'Kék 70',
	'green40': 'Zöld 40',
	'green50': 'Zöld 50',
	'red50': 'Vörös 50',
	'red60': 'Vörös 60',


	//Theme Palette Label
	'paletteLabel': '%{number} IBM paletta',
	'heatPaletteLabel': '%{number} IBM hőpaletta',
	'conditionalPaletteLabel': '%{number} IBM feltételes paletta',
	'carbonPaletteXLight': 'Carbon X Light',
	'carbonPaletteXDark': 'Carbon X Dark',
	'carbonPalettePurple': 'Lila',
	'carbonPaletteTeal': 'Pávakék',
	'carbonPaletteCyan': 'Cián',
	'carbonPaletteMagenta': 'Bíbor',
	'carbonPalettePurpleTeal': 'Lila szürkészöld',
	'carbonPaletteCyanMagenta': 'Cián magenta',
	'carbonPaletteGreenRed': 'Zöld vörös',
	'carbonPaletteGreenYellowRed': 'Zöld sárga vörös',
	'carbonPalettePurpleTealConvergent': 'Összefutó lila szürkészöld',
	'carbonPaletteCyanMagentaConvergent': 'Összefutó cián magenta',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM világos paletta',
	'userPaletteColor_defaultTheme': 'IBM alapértelmezett paletta',
	'userPaletteColor_darkTheme': 'IBM sötét paletta',

	// Dashboard
	'propDashboardBackgroundColor': 'Háttérszín',
	'propLayoutPositioning': 'Elrendezés pozicionálása',
	'propLayoutRelative': 'Relatív',
	'propLayoutAbsolute': 'Abszolút',
	'propLayoutPositioningCoachmarkTitle': 'Elrendezési stílus kiválasztása',
	'propLayoutPositioningCoachmarkContent': 'A relatív elrendezésekben a felületi elemek mérete és helyzete a képernyő méretéhez igazodik. Az abszolút elrendezés felületi elemei pontosan úgy jelennek meg, ahogyan a nézetben méretezi és elhelyezi őket, a képernyő méretétől függetlenül.',
	'gridText': 'Rács megjelenítése',
	'snapText': 'Rácshoz igazítás',
	'snapObjectsText': 'Objektumokhoz igazítás',
	'fitPageText': 'Oldal illesztése',
	'gridLabel': 'Rács',
	'heightUnit': 'm',
	'widthUnit': 'sz',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Oldalméret',
	'propPageSizePresetAriaLabel': 'Lapméret előbeállítás',
	'propPageSizePreset': 'Előbeállítás',
	'propPageSizePresetCustom': 'Egyéni',
	'propPageSizePreset16x9': '16:9 képernyő',
	'propPageSizePreset4x3': '4:3 képernyő',
	'propPageSizePresetInfographic': 'Infografika',
	'propPageSizeWidth': 'Szélesség',
	'propPageSizeHeight': 'Magasság',
	'propPageSizeWidthAriaLabel': 'Lapméret szélesség',
	'propPageSizeHeightAriaLabel': 'Lapméret magasság',
	'propPageSizeAdjustedMessage': 'Az oldalméret megnövelésre került, mert bejegyzése a minimum alatt volt vagy nem fért volna el a műszerfalban.',
	'propTabShow': 'Lapok megjelenítése',
	'propShowTabsInPreview': 'Lapok megjelenítése az előnézetben',
	'multilingualDashboardsLabel': 'Nyelvek',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Alapértelmezett',
	'multilingualDashboardsAddLinkText': 'Másik nyelv hozzáadása',
	'multilingualDashboardsSelect': 'Kijelölés',
	'multilingualDashboardsButtonLabel': 'Hozzáadás',
	'multilingualDashboardTranslationMode': 'Most fordítási üzemmódban van (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Kész',
	'multilingualDashboardRemainingStrings': 'Hátralévő fordítások száma: %{numTranslationsLeft}',
	'multilingualDashboardRemainingString': 'Hátralévő fordítások száma: 1',
	'multilingualDashboardsSetDefault': 'Alapértelmezett nyelv beállítása',
	'multilingualDashboardIconMore': 'További műveletek a(z) %{currentLanguage} nyelvhez',
	'multilingualDashboardIconTranslatableArea': 'Lefordítható terület',
	'multilingualDeleteTitle': 'Nyelv törlése',
	'multilingualDeleteLanguageWarning': 'Valóban törölni kívánja a(z) \'%{language}\' nyelvet?',
	'multilingualSelectLanguage': 'Nyelv kiválasztása',
	'confirmLayoutStyleUpgradeTitle': 'Minden lapra vonatkozik',
	'confirmLayoutStyleUpgrade': 'Ez az elrendezési stílus a műszerfal összes lapjára vonatkozik?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Törlés',
	'tabDeleteDialogTitle': 'Törölni kívánja ezt a lapot?',
	'tabDeleteDialogMessage': 'A lapon található összes tartalom is törlésre kerül.',

	// Vis widget
	'propVisTypeReturn': 'Megjelenítési típusok',
	'propVisDetails': 'Részletek',

	// Alignment picker
	'propAlignPickTop': 'Felülre igazítás',
	'propAlignPickRight': 'Jobbra igazítás',
	'propAlignPickBottom': 'Alulra igazítás',
	'propAlignPickLeft': 'Balra igazítás',
	'propAlignPickCenter': 'Középre igazítás',
	'propAlignPicker': 'Igazítás',

	// Toolbar picker
	'propToolbarPickBold': 'Félkövér',
	'propToolbarPickUnderline': 'Aláhúzás',
	'propToolbarPickItalic': 'Dőlt',
	'propToolbarPickJustifyLeft': 'Balra igazítás',
	'propToolbarPickJustifyCenter': 'Középre igazítás',
	'propToolbarPickJustifyRight': 'Jobbra igazítás',
	'propToolbarPickJustify': 'Sorkizárás',

	'propList': 'Lista',
	'propOrderedList': 'Rendezett lista',
	'propUnorderedList': 'Rendezetlen lista',

	// Symbol shapes
	'propCircle': 'Kör',
	'propTriangle': 'Háromszög',
	'propSquare': 'Négyzet',
	'propRect': 'Téglalap',
	'propStar': 'Csillag',
	'propCross': 'Kereszt',
	'propPlus': 'Összeadás',
	'propPoly': 'Sokszög',


	// True and false selection
	'propTrue': 'Igaz',
	'propFalse': 'Hamis',

	// Position selection
	'propLeft': 'Bal',
	'propRight': 'Jobb',
	'propTop': 'Felső',
	'propBottom': 'Alsó',

	// Interpolation options
	'propSmooth': 'Simított',
	'propStraight': 'Egyenes',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Mozgatás balra', // screen reader
	'srWidgetMoveUp': 'Mozgatás felfelé', // screen reader
	'srWidgetMoveRight': 'Mozgatás jobbra', // screen reader
	'srWidgetMoveDown': 'Lefelé', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Méret arányos növelése', // screen reader
	'srWidgetResizeSmaller': 'Méret arányos csökkentése', // screen reader
	'srWidgetResizeBiggerV': 'Méret függőleges növelése', // screen reader
	'srWidgetResizeSmallerV': 'Méret függőleges csökkentése', // screen reader
	'srWidgetResizeBiggerH': 'Méret vízszintes növelése', // screen reader
	'srWidgetResizeSmallerH': 'Méret vízszintes csökkentése', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Forgatás az óramutató járásával megegyezően', // screen reader
	'srWidgetRotateCCW': 'Forgatás az óramutató járásával ellentétesen', // screen reader

	// Recommended types
	'visChange': 'Megjelenítés módosítása',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Megjelenítés',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Az eszközelemen belüli navigáláshoz nyomja le az F12 billentyűt',
	'f10KeyDescription': 'Az eszközelem fókusznézetének indításához nyomja le az F10 billentyűt',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} %{value} értékkel',

	'shapeColorLabel': 'Alakzat színe',
	'showLegendLabel': 'Jelmagyarázat megjelenítése',

	//Webpage
	'webpageWidgetTitle': 'Weblap eszközelem',
	'webpagePasteLink': 'Illessze be az URL-címet, majd az Enter lenyomásával mentse.',
	'propWebpageLink': 'Weblap URL-címe',
	'propWebpageTitle': 'Weblap címe',
	'propWebpageTitleDescription': 'A weblap címe',
	'webpageUrl': 'Weboldal URL',
	'noWebpageSelected': 'Nincs kiválasztva weboldal',
	'enterWebpageUrl': 'Itt adja meg a weboldal URL-címét',
	'propWebpageTop': 'Weblap tulajdonságai', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'A weboldal URL-címe hiányzik.',
	'webpageUrlValidationError': 'A weboldal URL-címe érvénytelen.',
	'webpageHttpValidationError': 'A weboldalt egy HTTPS hivatkozáson keresztül lehet elérni.',
	'webpageInvalidDomainError': 'A weboldal URL olyan tartományra mutat, amelyet nem hagyott jóvá adminisztrátora. Az adminisztrátor által jóváhagyott tartományok: "%{domains}".',

	//VizState
	'vzErrorLoading': 'A megjelenítés nem tölthető be',
	'vzErrorLoadingMissingData': 'A megjelenítés nem tölthető be, a kontextusadatok hiányoznak',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Média eszközelem',
	'mediaPasteLink': 'Illessze be az URL-címet, majd az Enter lenyomásával mentse.',
	'mediaUrl': 'Adathordozó URL',
	'noMediaSelected': 'Nincs kiválasztva adathordozó',
	'enterMediaUrl': 'Itt adja meg az adathordozó URL-címét',
	'videoHeight': 'Magasság:',
	'videoWidth': 'Szélesség:',
	'propMediaLink': 'Médiahivatkozás',
	'propMediaTitle': 'Médiacím',
	'propMediaTitleDescription': 'A médiatartalom címe',
	'propMediaTop': 'Média tulajdonságai', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'A médiahivatkozás URL-címe hiányzik.',
	'mediaUrlValidationError': 'A médiafájl URL-címe érvénytelen.',
	'mediaUnknownValidationError': 'Ez a médiatípus nem támogatott.',
	'mediaHttpValidationError': 'A médiafájlt egy HTTPS hivatkozáson keresztül lehet elérni.',
	'mediaInvalidDomainError': 'Az adathordozófájl URL olyan tartományra mutat, amelyet nem hagyott jóvá adminisztrátora. Az adminisztrátor által jóváhagyott tartományok: "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Tulajdonságok', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Adathalmaz',
	'dataViewsLabel': 'Nézet',
	'columnQuality': 'Adatok minősége',
	'columnProperties': 'Adatok tulajdonságai',

	'dataQuality': 'Adatok minősége',
	'dataQualityRowCount': 'Sorok száma',
	'dataQualityDistribution': 'Elosztás',
	'dataRowLabel': 'Adatok',

	// Modelling UI
	'typeColumn': 'Típus',
	'modellingColumnType': 'Típus',
	'modellingColumnAggregation': 'Összesítés',
	'modellingColumnUsage': 'Használat',
	'modellingColumnSort': 'Rendezés',
	'modellingColumnFormat': 'Formátum',
	'modellingColumnCategory': 'Kategória',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Betöltés...',

	'modellingProcessing': 'Feldolgozás...',
	'modellingImport': 'Importálás',
	'modellingReimport': 'Újraimportálás',
	'modellingDatasourceTitle': 'Adatforrás',
	'modellingImportStartedTitle': 'Az importálás elindult',
	'modellingImportStartedText': 'Az adatok importálása eltarthat egy ideig.\n\n(Amíg az adatok importálása folyamatban van, létrehozhat egy nézetet.)',
	'importDatasourceTitle': 'Kapcsolatok',
	'dropHere': 'Húzza ide egy új adatforrás létrehozásához...',
	'browseButton': 'Tallózás',
	'errorNoData': 'Nincsenek feldolgozható adatok.',
	'errorNoFile': 'Nincs feltölthető fájl.',
	'errorUploadFailed': 'A feltöltés nem lehetséges.',
	'uploadSucceessful': 'Sikeres feltöltés',
	'del_datasourceTitle': 'Adathalmaz törlése',
	'del_datasourceMsg': 'Biztosan törli a következőt: \'%{name}\'?',
	'modellingFileUpdate': 'Frissítés',
	'modellingFileUpdateTitle': 'Adathalmaz frissítése',
	'modellingFileUpdateDescription': 'Biztosan frissíti a következőt: \'%{name}\'?',
	'modellingFileUpdatingTitle': '"%{name}" frissítése',
	'modellingUpdateStartedTitle': 'A frissítési importálás elindult',
	'modellingUpdateStartedText': 'Az adatok frissítése eltarthat egy ideig.\n\n(Amíg az adatok frissítése folyamatban van, létrehozhat egy nézetet.)',
	'modellingErrorImportUploadNoFile': 'Nincs feltölthető fájl.',
	'modellingErrorImportUploadFailed': 'A feltöltés nem lehetséges.',
	'modellingErrorImportUploadInvalidType': 'A fájl típusa érvénytelen.',
	'modellingErrorImportUploadTableFailed': 'A táblázatok lekérése nem sikerült.',
	'modellingIntentResultsTitle': 'Válassza ki a használni kívánt, javasolt adathalmazt',
	'modellingColumnViewRelationships': 'Kapcsolódó táblák megtekintése',
	'modellingTableRelatedTables': 'A(z) \'%{name}\' kapcsolódó táblái',
	'modellingTable': '%{name} - Tábla',
	'modellingColumnIncludedInDataSet': 'Hozzáadva',
	'modellingDataSet': 'Adathalmaz',
	'modellingViewInDataSet': 'Megtekintés adathalmazban',
	'modellingViewRelatedTables': 'Kapcsolódók megtekintése',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nincs kapcsolódó tábla',

	'modellingValidatingDataset': 'Ellenőrzés...',
	'datasetFinishedRefreshing': 'A(z) %{datasetName} adathalmaz frissítésre került. ',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Összekapcsolási útvonal feloldása:',
	'modellingJoinColumns': 'Összekapcsolási útvonal megadása a(z) %{name} táblához',
	'modellingJoinToTable': 'Összekapcsolás a(z) %{name} táblával',

	// Data Quality
	'excluded': 'Kizárt',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'F',
	'metricPrefixTrillion': 'S',
	'metricPrefixQuadrillion': 'L',

	//Column Flyout
	'modellingColumnFilter': 'Szűrő',
	'modellingColumnSortNone': 'Rendezés törlése',
	'modellingColumnSortAsc': 'Növekvő sorrendbe rendezés',
	'modellingColumnSortDesc': 'Csökkenő sorrendbe rendezés',
	'modellingColumnRemove': 'Oszlop eltávolítása',

	// Import File Browser
	'dropboxPageTitle': 'Új Dropbox-kapcsolat',
	'sizeColumn': 'Méret',

	//Modelling Column Property Values
	'dataType_string': 'Karakterlánc',
	'dataType_date': 'Dátum',
	'dataType_integer': 'Egész szám',
	'dataType_double': 'Dupla',
	'dataType_float': 'Lebegőpontos',
	'dataType_boolean': 'Logikai',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Darabszám',
	'defaultAggregation_countdistinct': 'Egyedi darabszám',
	'defaultAggregation_max': 'Maximális',
	'defaultAggregation_min': 'Minimális',
	'defaultAggregation_avg': 'Átlag',
	'defaultAggregation_sum': 'Összeg',
	'defaultAggregation_auto': 'Automatikus (%{aggregationType})',

	'type_fact': 'Tény',
	'type_attribute': 'Attribútum',

	'defaultSort_none': 'Nincs rendezés',
	'defaultSort_asc': 'Növekvő sorrendbe rendezés',
	'defaultSort_desc': 'Csökkenő sorrendbe rendezés',

	'category_none': 'Nincs',
	'category_location': 'Hely',
	'category_monetary': 'Pénzügyi',
	'category_time': 'Idő',

	// Root menu
	'rootMenuTitle': 'Főmenü',

	'errorMessageTitle': 'Hiba',
	'errorMessageDetails': 'Részletek: ',
	'errorMessageTitleAssetAlreadyExists': 'Az eszköz már létezik',

	'defaultTabTitle': '%{index} lap',
	'tabAddBtnTitle': 'Új lap hozzáadása',

	'unsupportedConditionalFormattingEncountered': 'A feltételes formázás néhány oszlopra már nincs alkalmazva.',


	// Homepage View
	'nameColumn': 'Név',
	'creatorColumn': 'Létrehozta:',
	'creationDateColumn': 'Létrehozás dátuma',
	'versionColumn': 'Változat',
	'modifiedColumn': 'Utolsó módosítás',

	'filterBy': 'Elemek szűrése',
	'allFilter': 'Minden elem',
	'createdByMeFilter': 'Általam létrehozva',
	'sharedWithMeFilter': 'Velem megosztva',
	'favoritesFilter': 'Kedvenceim',
	'recentsFilter': 'Legutóbb hozzáadva',
	'sortBy': 'Rendezési szempont',

	// Sort Menu
	'sortModified': 'Módosítva',
	'sortUpdated': 'Frissítve',
	'sortName': 'Név',

	'viewAs': 'Megtekintés mint',
	'thumbnailsView': 'Megtekintés miniatűrként',
	'listView': 'Megtekintés listaként',
	'createMenu': 'Létrehozás',
	'newAppItem': 'Műszerfal',
	'newDataSet': 'Adathalmaz',

	'menuSelectionState_a11y': 'A(z) "%{item}" kiválasztója beállítva a következőre: "%{selectedItem}"',

	'unableToShareItem': 'A(z) "%{item}" elem nem osztható meg.',
	'toastFetchingContent': 'További tartalom lekérése...',
	'unableToGetData': 'A tartalom lekérése nem sikerült.',
	'unableToFavorite': 'A Kedvenc állapot nem módosítható.',
	'hpErrorMissingRequiredOptions': 'A kötelező inicializálási beállítások hiányoznak',
	'unableToOpenBoard': 'A(z) "%{name}" nem nyitható meg.',
	'unableToDuplicateBoard': 'A(z) "%{name}" nem duplikálható. ',
	'unableToCreateBoard': 'A(z) "%{name}" nem hozható létre.',
	'unableToCreateBoardNameConflict': 'Már létezik ilyen nevű eszköz.',

	// DataSet Detail View
	'status': 'Állapot',
	'numberOfRows': 'Sorok',
	'importWarnings': 'Figyelmeztetések',
	'lineNumbers': 'Sorok',
	'excerptFromSource': 'Kivonat',
	'reason': 'Ok',
	'numberOfRowsDropped': 'eldobott sorok',
	'oneRowDropped': '1 sor el lett dobva',

	// Type Menu
	'typeMenuLabel': 'Típus',
	'dashboardsLabel': 'Műszerfalak',
	'datasetsLabel': 'Adathalmazok',
	'storiesLabel': 'Történetek',
	'allLabel': 'Összes típus',

	// Board Page View App Bar
	'datasets': 'Adathalmazok',
	'settings': 'Tulajdonságok',
	'add': 'Hozzáadás',
	'widgets': 'Eszközelemek',
	'dashboardProperties': 'Műszerfal tulajdonságai',
	'searchPanel' : 'Keresés',
	'pins': 'Gyűjtemény',
	'pinsOld': 'Saját tűk',
	'pinsDateFilterHeading' : 'Rögzített dátum',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} rögzítés |||| %{smart_count} rögzítés',
	'pinSearch': 'Keresés',
	'pinSearchOld': 'Tűk keresése',
	'pinListView': 'Listanézet',
	'pinIconView': 'Ikonnézet',
	'pinRemove': 'Eltávolítás',
	'pinCreate': 'Létrehozás',
	'pinDeleteError': 'Egy vagy több eszköz nem törölhető a gyűjteményből. Próbálja újra később.',
	'pinDeleteErrorOld': 'Egy vagy több tű nem törölhető. Próbálja újra később.',
	'pinRetrieveError': 'Egy vagy több tű nem kérhető le. Próbálja újra később.',
	'NoPinsCollected': 'Nincsenek rögzített megjelenítések',
	'pinDeletedToast': 'A tű eltávolítása megtörtént',
	'pinAddedToast': 'A tű sikeresen hozzá lett adva a Saját tűkhöz',
	'pinningToast': 'Rögzítés feldolgozása...',
	'pinDateFilter': 'Dátumszűrő',
	'pinDateFilterAll': 'Mind',
	'pinDateFilterToday': 'Ma',
	'pinDateFilterYesterday': 'Tegnap',
	'pinDateFilterPastWeek': 'Múlt hét',
	'pinDateFilterPastMonth': 'Előző hónap',
	'pinDateFilterEarlier': 'Korábban',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Cím szerkesztése',
	'toolbarActionSort': 'Rendezés',
	'toolbarActionSortAscending': 'Növekvő sorrendbe rendezés',
	'toolbarActionSortDescending': 'Csökkenő sorrendbe rendezés',
	'toolbarActionSortAuto': 'Automatikus (%{sortOrder})',
	'toolbarActionFormat': 'Adatok formázása',
	'toolbarActionFormatAbbreviation': 'Rövidítés',
	'toolbarActionFormatNone': 'Automatikus',
	'toolbarActionFilter': 'Szűrő',
	'toolbarActionTopBottom': 'Felső vagy alsó',
	'toolbarActionAddShape': 'Alakzat hozzáadása',
	'toolbarActionRmvShape': 'Alakzat eltávolítása',
	'toolbarActionToggleShapeDrop': 'Infografika alakja',
	'toolbarActionToggleShapeDropTitle': 'Infografika létrehozása',
	'toolbarActionToggleShapeDropText': 'Húzzon egy alakot erre a mezőre az infografika létrehozásához.',
	'toolbarActionAggregationType': 'Összegzés',
	'toolbarDeleteActionText': 'Oszlop eltávolítása',
	'toolbarActionFilterLocalKeepSelected': 'Megtartás',
	'toolbarActionFilterLocalExcludeSelected': 'Kizárás',
	'toolbarActionFilterAllKeepSelected': 'Szűrő',
	'toolbarActionSimpleCalculation': 'Egyszerű számítás',
	'toolbarActionDrillBack': 'Vissza',
	'toolbarActionDrillUp': 'Felfúrás',
	'toolbarActionDrillDown': 'Lefúrás',
	'toolbarActionNavigate': 'Navigálás',
	'toolbarActionCreateFilterGroup': 'Új kapcsolat létrehozása',
	'toolbarActionDisconnectFilterGroup': 'Összes hivatkozás megszüntetése',
	'toolbarActionLinkFilterGroup': 'Hozzáadás meglévő kapcsolathoz',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Hozzáadás',
	'sidebarMultiselect': 'Többszörös kijelölés váltása',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} kiválasztva',

	'multiselectWithTotalMsg': '%{count} / %{total}',
	'sidebarGoBack': 'Vissza',

	//DataSet pane
	'errorLoadingDataSets': 'Az adathalmaz nem tölthető be',
	'errorLoadingDataSetMetaData': 'Az adathalmaz nem tölthető be',
	'dataSetPaneLastUpdated': 'Legutóbbi frissítés: %{date}',
	'dataSetPaneDateUnknown': 'Ismeretlen',
	'sourcePaneLabel': 'Kiválasztott források',
	'addSourceLabel': 'Forrás hozzáadása',
	'find_label': 'Keresés',
	'navigationPathsLabel': 'Navigációs útvonalak',

	//widgetlist
	'errorLoadingWidgetList': 'Az objektumokat nem lehet betölteni.',
	'errorLoadingThemeFile': 'A témameghatározást nem lehet betölteni',
	'errorLoadingLayoutFile': 'A nézetet nem lehet betölteni.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Az elérhető megjelenítési meghatározásokat nem lehet betölteni',

	'dwErrorLoadingVisualizationNotFound': 'Az objektumot nem lehet betölteni, mert hiányzik belőle egy megjelenítési meghatározás',
	'dwErrorLoadingVisualizationListNotFound': 'A megjelenítést nem lehet betölteni.',
	'dwErrorRunningQuery': 'Az adatok lekérése nem sikerült a(z) %{datasetName} adathalmazból.',
	'dwErrorGeoData': 'Probléma merült fel a földrajzi adatok térképen történő megjelenítése során. Válasszon egy másik megjelenítési típust. ',
	'dwPromptSignonCancelWarning': 'A megjelenítéshez tartozó adatok nem érhetők el. Adja meg a megfelelő hitelesítő adatokat.',
	'dwErrorMissingDataset': 'A megjelenítés nem tölthető be, mert a hozzárendelt \'%{datasetName}\' adathalmaz nem érhető el.',
	'dwErrorRenderingVisualization': 'Ezt a megjelenítést nem lehet betölteni.',
	'dwErrorVisualizationTooSmall': 'A megjelenítés túl kicsi, így nem jeleníthetők meg a benne lévő adatok. Nagyítsa a megjelenítést vagy korlátozza a benne tárolt adatokat.',
	'aria_label_datatable': 'Adattábla',
	'aria_key_navi_datatable_desc': 'A nyílbillentyűkkel navigálhat az egyes cellákra. A Control és a Home billentyű együttes megnyomásával léphet az első, a Control és az End billentyű együttes megnyomásával pedig az utolsó sorra.',
	'geomapUnrecognizedLocations': 'Ismeretlen helyek:',
	'geomapAmbiguousLocations': 'Nem egyértelmű régiók',

	// custom widget
	'customWidget': 'Egyéni eszközelem',
	'customWidgetsTitle': 'Egyéni eszközelemek',
	'noCustomWidgets': 'Nincsenek egyéni eszközelemek',

	// Action names
	'toggleContextBar': 'Kontextussáv váltása',
	'delete': 'Törlés',
	'share': 'Megosztás',
	'unshare': 'Megosztás megszüntetése',
	'rename': 'Átnevezés',
	'close': 'Bezárás',
	'duplicate': 'Többszörözés',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Újra próbálkozás',

	'changeTemplate': 'Sablon módosítása',

	// Aggregation Types
	'sum': 'Összeg',
	'count': 'Darabszám',
	'countdistinct': 'Egyedi darabszám',
	'avg': 'Átlag',
	'min': 'Minimális',
	'max': 'Maximális',
	'custom': 'Egyéni',
	'calculated': 'Számított',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '%-os változás',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Megjelenítési feltételek...',
	'QuickAddResultsHeader': 'Adatmegjelenítések',
	'NoQuickAddResults': 'Nincs a szándékának megfelelő találat. Létrehoz egy új adathalmazt?',
	'NoQuickAddResultsRetry': 'Nem található egyezés. Próbálkozzon újból más kifejezésekkel.',
	'templateWidgetTitle': 'Sablon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(üres)',

	'nullValueContent': '(nincs érték)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Szövegszűrő - %{columnName}',

	'textFilterSelectTab': 'Kijelölés',

	'textFilterConditionTab': 'Feltétel beállítása',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nincs elérhető elem.',

	'textFilterEquals': 'Egyenlő',
	'textFilterContains': 'Tartalmazza a következőt:',
	'textFilterBeginsWith': 'Ezzel kezdődik:',
	'textFilterEndsWith': 'Erre végződik:',
	'textFilterDoesNotEqual': 'Nem egyenlő',
	'textFilterDoesNotContain': 'Nem tartalmazza a következőt:',
	'textFilterDoesNotBeginWith': 'Nem a következővel kezdődik:',
	'textFilterDoesNotEndWith': 'Nem a következőre végződik:',
	'textFilterSampleText': 'Például: A',

	'textFilterAndButton': 'És',
	'textFilterOrButton': 'Vagy',

	'dateFilterMessage': 'Dátumtartomány kiválasztása',
	'dateRangeControlRegionLabel': 'Dátumtartomány szűrő - %{columnName}',
	'dateFilterRangeOption': 'Tartománybeállítás',
	'dateFilterDateLabel': 'Dátum',
	'dateFilterBlank': '(üres)',
	'dateFilterBefore': 'Ez előtt:',
	'dateFilterAfter': 'Ez után:',
	'dateFilterBetween': 'Az alábbiak között:',
	'dateFilterSampleText': 'ÉÉÉÉ-HH-NN',
	'dateTitle': 'Dátum',
	'dateIncludeBlankLabel': 'Üres dátum belefoglalása',

	'timeTitle': 'Idő',
	'timeFilterMessage': 'Időponttartomány kiválasztása',
	'dateTimeFilterMessage': 'Dátum- és időponttartomány kiválasztása',

	'topbottomNumberOfResultsLabel': 'Az eredmények száma',
	'topbottomPercentLabel': 'Százalék',
	'topbottomNumberOfResultsLimit': '%{lower} és %{higher} között',
	'topbottomSelectOption': 'Első vagy utolsó lehetőség',
	'topbottomOptionLabel': 'Megjelenítés',
	'searchByLabel': 'A következő szerint:',
	'searchNoMatches': 'Nincs találat',
	'topbottomRankColumnLabel': 'Rangsoroszlop hozzáadása táblához',
	'topbottomNone': 'Nincs',
	'topCount': 'Első elemek száma',
	'topPercent': 'Felső %',
	'bottomCount': 'Utolsó elemek száma',
	'bottomPercent': 'Alsó %',
	'topbottomSearchColumn': 'Oszlop keresése',
	'searchColumnAriaLabel': 'Oszlop keresése. Adja meg a keresett oszlop nevét, majd a lefelé mutató nyíllal keresse meg az oszlopot a listában',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Törlés',

	'rangeFilterControlRegionLabel': 'Tartományszűrő - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Csúszka vezérlőelem, a bal és a jobb nyílbillentyűkkel mozgathatja a csúszka fogópontjait',
	'sliderHandleLabel': 'Csúszka fogópontja',
	'a11ySliderHandleLabel': 'Csúszka fogópontja %{sliderValue}',
	'sliderInputLabel': 'érték',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Az ebben a megjelenítésben használt egyes adathalmazelemek nem érhetők el.',
	'datasetItemUnavailable': 'Ez az adathalmazelem nem érhető el',

	//Authoring topBottom
	'topOperator': 'Felső',
	'bottomOperator': 'Alsó',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value}, %{columnLabel} szerint',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Csak ez az objektum',
	'deleteTopBottom': 'Az első vagy az utolsó elemek számának törlése',
	'editTopBottom': 'Az első vagy az utolsó elemek számának szerkesztése',
	'deleteDrillState': 'Aktuális lefúrási állapot törlése',
	'ariaDeleteDrillStateLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'drillUpStateTitle': 'Felfúrás',
	'drillDownStateTitle': 'Lefúrás',
	'ariaEditTopBottomLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteTopBottomLabel': 'Az első vagy az utolsó elemek számának törléséhez nyomja le a DELETE billentyűt.',

	// Authoring filtering
	'dimFilterIn': 'Tartalmazza a következőt: %{in}',
	'dimFilterNotIn': 'Nem tartalmazza a következőt: %{out}',
	'measureFilterBetween': '%{lowerBound} és %{upperBound} között',
	'measureFilterNotBetween': 'Nem %{lowerBound} és %{upperBound} között',
	'gtFilter': '%{lowerBound} után',
	'ltFilter': '%{upperBound} előtt',
	'notGtFilter': 'Nem %{lowerBound} után',
	'notLtFilter': 'Nem %{upperBound} előtt',
	'localFilterTitle': 'Csak ez az objektum',
	'globalFilterTitle': 'Minden objektum',
	'deleteFilter': 'Szűrő törlése',
	'editFilter': 'Szűrő szerkesztése',
	'ariaEditFilterLabel': 'A szűrő szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteFilterLabel': 'A szűrő törléséhez nyomja le a DELETE billentyűt.',

	// Prompts
	'ariaEditPrompt': 'Az adatkérési érték megváltoztatásához nyomja le az ENTER billentyűt.',

	'moreDataIndicator': 'Az adatok %{threshold} elem esetében kivágásra kerültek. Alkalmazzon szűrőt kevesebb elem megjelenítéséhez.',

	// data point filtering
	'dataPointFilterTitle': 'Adatpontok',
	'dataPointFilterIncludeSummary': '%{valueCount} adatpontot tartalmaz ',
	'dataPointFilterExcludeSummary': '%{valueCount} adatpontot kizár',

	// DB2 connection page
	'db2Database': 'DB2 adatbázis (%{jdbcConnection})',
	'db2Title': 'Csatlakozás az IBM DB2-adatbázishoz',

	// Database
	'databaseConnectionMessage': 'Adatbázis-kapcsolat részleteinek megadása:',
	'connectionString': 'Adatbázis-kapcsolódási karakterlánc',
	'databaseCredentials': 'Hitelesítő adatok: ',
	'databaseUserName': 'Felhasználónév',
	'databasePassword': 'Jelszó',
	'databaseConnect': 'Kapcsolódás',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Keresett kifejezés megadása:',
	'twitterKeyword': 'Kulcsszó',
	'twitterSearch': 'Keresés',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'A(z) %{error} nézet nem hozható létre.\nMeghiúsult művelet: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Eszközelemszűrők',
	'missingColumn': 'Hiányzik: %{columnLabel}',
	'missingFiltering': 'Hiányzó szűrők a következő oszlopazonosítóknál:',
	'heatByLabel': 'Intenzitás e szerint:',
	'evColumns': 'Oszlopok',
	'evLocalFilters': 'Helyi szűrők',
	'evExpand': 'Kibontás',
	'evFilterTooltip': 'Szűrő',
	'evAdd': 'Oszlop hozzáadása',

	// Navigation View
	'navigationBack': 'Vissza',

	// Pinning
	'contentPinFail': 'A tartalom nem gyűjthető össze. Próbálja újra később.',
	'contentPinFailOld': 'A tartalom nem rögzíthető. Próbálja újra később.',

	// Layouts
	'dropZoneLabel': 'Húzza ide a teljes mérethez',

	//Share
	'shareDefaultPageTitle': '%{index} oldal',

	'nextPage': 'Következő oldal',
	'previousPage': 'Előző oldal',

	'assetAssembly': 'nézet',

	'toolbar_save': 'Mentés',
	'brgr_saveAs': 'Mentés másként',
	'brgr_refresh': 'Frissítés',

	// Save
	'saving': 'Mentés...',
	'save_success': 'A rendszer mentette a nézetet.',
	'save_failure': 'Sajnáljuk. A nézet mentése nem sikerült. Próbálkozzon ismét később.',
	'dashboard_save_success': 'A rendszer mentette a műszerfalat.',

	'geminiLeave': 'Az IBM Watson Analytics elhagyására készül.',

	'warning': 'Figyelmeztetés',
	'missingDataSetData': 'Az adathalmazhoz tartozó adatok nem érhetők el. Frissítse az adathalmazt, vagy lépjen kapcsolatba az adminisztrátorral a forráshoz való hozzáférésért.',

	// Calculations
	'error_calculation_in_use': 'A kijelölt számítás használatban van, és nem törölhető.',

	'resize': 'Átméretezés',
	'rotate': 'Elforgatás',
	'moveHandle': 'Eszközelem áthelyezése',
	'expandHandle': 'Kibontás',
	'panHandle': 'Pásztázás',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigálás ide:',

	// Slide out titles
	'shapeSlideoutTitle': 'Alakzatok',
	'textSlideoutTitle': 'Szöveg',
	'mediaSlideoutTitle': 'Adathordozó',
	'visualizationSlideoutTitle': 'Megjelenítések',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'A megadott JSON érvénytelen. További tájékoztatásért tekintse meg a hibanaplót.',

	// Widget type labels
	'shape_label': 'Alakzat',
	'image_label': 'Kép',
	'data_label': 'Diagram',
	'media_label': 'Adathordozó',
	'text_label': 'Szöveg',
	'embedMedia_label': 'Adathordozó',
	'youtube_label': 'YouTube-videó',
	'webpage_label': 'Weboldal',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Alakzat',
	'noExtraText_shape_numbered': '(%{number}) alakzat',
	'few_shape': '%{count} alakzatok csoportja',
	'many_shape': '%{count} alakzatok csoportja',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} kép',
	'one_image_numbered': '%{text} kép (%{number})',
	'noExtraText_image': 'Kép',
	'noExtraText_image_numbered': 'Kép (%{number})',
	'few_image': '%{count} képek csoportja',
	'many_image': '%{count} képek csoportja',
	'noExtraText_text': 'Üres szövegmező',
	'noExtraText_text_numbered': 'Üres szövegmező (%{number})',
	'few_text': '%{count} szövegmezők csoportja',
	'many_text': '%{count} szövegmezők csoportja',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Kockamegjelenítő',
	'pacubeviewer_named': '%{name} kockamegjelenítő',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} a(z) %{row_level1} és %{column_level1} kereszttábla szerint',
	'crosstab_opt_mapping_numbered': '%{values} a(z) %{row_level1} és %{column_level1} (%{number}) kereszttábla szerint',
	'crosstab_has_mapping': '%{values} a(z) %{row_level1} kereszttábla szerint',
	'crosstab_has_mapping_numbered': '%{values} a(z) %{row_level1} (%{number}) kereszttábla szerint',
	'crosstab_no_mapping': 'Üres kereszttábla',
	'crosstab_no_mapping_numbered': 'Üres kereszttábla (%{number})',
	'crosstab_named': '%{name} kereszttábla',
	'crosstab_named_numbered': '%{name} kereszttábla (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tábla',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tábla (%{number})',
	'JQGrid_no_mapping': 'Üres tábla',
	'JQGrid_no_mapping_numbered': 'Üres tábla (%{number})',
	'JQGrid_named': '%{name} tábla',
	'JQGrid_named_numbered': '%{name} tábla (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hierarchia',
	'hierarchy_has_mapping_numbered': '%{level1} hierarchia (%{number})',
	'hierarchy_no_mapping': 'Üres hierarchia',
	'hierarchy_no_mapping_numbered': 'Üres hierarchia (%{number})',
	'hierarchy_named': '%{name} hierarchia',
	'hierarchy_named_numbered': '%{name} hierarchia (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} térkép',
	'map_has_mapping_numbered': '%{categories} térkép (%{number})',
	'map_no_mapping': 'Üres térkép',
	'map_no_mapping_numbered': 'Üres térkép (%{number})',
	'map_named': '%{name} térkép',
	'map_named_numbered': '%{name} térkép (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} összegző érték',
	'summary_has_mapping_numbered': '%{actual} összegző érték (%{number})',
	'summary_no_mapping': 'Üres összegző érték',
	'summary_no_mapping_numbered': 'Üres összegző érték (%{number})',
	'summary_named': '%{name} összegző érték',
	'summary_named_numbered': '%{name} összegző érték (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} a(z) %{sparkline.time} KPI szerint',
	'kpi_opt_mapping_numbered': '%{actual} %{sparkline.time} KPI szerint (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Üres KPI',
	'kpi_no_mapping_numbered': 'Üres KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografika',
	'infographicSummary_has_mapping_numbered': '%{actual} infografika (%{number})',
	'infographicSummary_no_mapping': 'Üres infografika',
	'infographicSummary_no_mapping_numbered': 'Üres infografika (%{number})',
	'infographicSummary_named': '%{name} infografika',
	'infographicSummary_named_numbered': '%{name} infografika (%{number})',
	'noExtraText_youtube': 'YouTube-videó',
	'noExtraText_youtube_numbered': 'YouTube videó (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube videó',
	'one_youtube_numbered': '%{text} YouTube videó (%{number})',
	'few_youtube': '%{count} YouTube videók csoportja',
	'many_youtube': '%{count} YouTube videók csoportja',
	'noExtraText_embedMedia': 'Médiahivatkozás',
	'noExtraText_embedMedia_numbered': 'Médiahivatkozás (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} médiahivatkozás',
	'one_embedMedia_numbered': '%{text} médiahivatkozás (%{number})',
	'few_embedMedia': '%{count} médiahivatkozások csoportja',
	'many_embedMedia': '%{count} médiahivatkozások csoportja',
	'noExtraText_media': 'Adathordozó',
	'noExtraText_media_numbered': 'Média (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} média',
	'one_media_numbered': '%{text} média (%{number})',
	'few_media': 'Group of %{count} média',
	'many_media': '%{count} médiacsoport',
	'noExtraText_webpage': 'Weboldal',
	'noExtraText_webpage_numbered': 'Weboldal (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} weboldal',
	'one_webpage_numbered': '%{text} weboldal (%{number})',
	'few_webpage': '%{count} weboldalak csoportja',
	'many_webpage': '%{count} weboldalak csoportja',
	'one_unknown': 'Egy objektum',
	'one_unknown_numbered': 'Egy objektum (%{number})',
	'few_unknown': '%{count} objektumok csoportja',
	'many_unknown': '%{count} objektumok csoportja',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Tovább',
	'previous': 'Előző',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Az aktuális navigációs csoport: %{navigation_group_name}',

	//Page Context
	'filterBlank': '(üres)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'A szűrőértékek nem tölthetők be',
	'editTimelineHighlight': 'Kiemelés szerkesztése',

	'filterDockChevronLeft': 'Adatok görgetése',
	'filterDockChevronRight': 'Adatok görgetése',
	'expand': 'Kibontás',
	'collapse': 'Visszazárás',

	//Reset Dashboard
	'dashboardResetTitle': 'Műszerfal alaphelyzetbe állítása',
	'dashboardResetMessage': 'Biztosan alaphelyzetbe állítja a műszerfalon végzett módosításokat?',
	'dashboardResetToast': 'A rendszer visszaállította a műszerfalat.',

	//Generate PDF
	'buildingPDF': 'PDF összeállítása ...',
	'exportPDF': 'Exportálás a PDF formátumba',
	'pageSize': 'Oldalméret',
	'orientation': 'Tájolás',
	'filtersPresentPDF': 'A megjelenítés(ek)re alkalmazott szűrő(k) az előző oldalon:',
	'errorPDF': 'A PDF nem állítható elő. Frissítsen, majd próbálkozzon újra.',
	'printPDFInfo': 'Dokumentáció megtekintése',
	'pdfWidget': 'Felületi elem',
	'includeFilters': 'Szűrő részleteinek megjelenítése',
	'portrait': 'Álló',
	'landscape': 'Fekvő',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'A rendszer frissítette a műszerfalat. Mentsen most az optimális teljesítmény megőrzése érdekében.',

	'ariaFullScreenMessage': 'A kilépéshez a teljes képernyős módból nyomja meg az Escape billentyűt',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} zárt hierarchiájú buborékdiagram',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} zárt hierarchiájú buborékdiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Üres zárt hierarchiájú buborékdiagram',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Üres zárt hierarchiájú buborékdiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} zárt hierarchiájú buborékdiagram',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} zárt hierarchiájú buborékdiagram (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} a(z) %{values} marimekko diagram szerint',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} a(z) %{values} marimekko diagram szerint (%{number})',
	'LIVE_marimekko_no_mapping': 'Üres marimekko diagram',
	'LIVE_marimekko_no_mapping_numbered': 'Üres marimekko diagram (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko diagram',
	'LIVE_marimekko_numbered': '%{name} marimekko diagram (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} napsugár diagram',
	'LIVE_sunburst_has_mapping_numbered': '%{values} napsugár diagram (%{number})',
	'LIVE_sunburst_no_mapping': 'Üres napsugár diagram',
	'LIVE_sunburst_no_mapping_numbered': 'Üres napsugár diagram (%{number})',
	'LIVE_sunburst_named': '%{name} napsugár diagram',
	'LIVE_sunburst_named_numbered': '%{name} napsugár diagram (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} tényezőelemzési diagram',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} tényezőelemzési diagram (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Üres tényezőelemzési diagram',
	'LIVE_decision_analysis_no_mapping_numbered': 'Üres tényezőelemzési diagram (%{number})',
	'LIVE_decision_analysis_named': '%{name} tényezőelemzési diagram',
	'LIVE_decision_analysis_named_numbered': '%{name} tényezőelemzési diagram (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} a(z) %{columnValue} és %{lineValue} sor- és oszlopdiagram szerint',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} a(z) %{columnValue} és %{lineValue} sor- és oszlopdiagram szerint (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} és %{lineValue} sor- és oszlopdiagram ',
	'LIVE_line_column_has_mapping_numbered': '%{categories} a(z) %{columnValue} és %{lineValue} sor- és oszlopdiagram szerint (%{number})',
	'LIVE_line_column_no_mapping': 'Üres szerint vonal- és oszlopdiagram',
	'LIVE_line_column_no_mapping_numbered': 'Üres sor- és oszlopdiagram (%{number})',
	'LIVE_line_column_named': '%{name} sor- és oszlopdiagram',
	'LIVE_line_column_named_numbered' : '%{name} sor- és oszlopdiagram (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} a(z) %{y} és %{size} buborékdiagram szerint ',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} a)z) %{y} és %{size} buborékdiagram szerint (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Üres buborékdiagram',
	'LIVE_bubble_chart_no_mapping_numbered': 'Üres buborékdiagram (%{number})',
	'LIVE_bubble_chart_named': '%{name} buborékdiagram',
	'LIVE_bubble_chart_named_numbered': '%{name} buborékdiagram (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} felsorolás diagram',
	'LIVE_bullet_has_mapping_numbered': '%{actual} felsorolás diagram (%{number})',
	'LIVE_bullet_no_mapping': 'Üres felsorolás diagram',
	'LIVE_bullet_no_mapping_numbered': 'Üres felsorolás diagram (%{number})',
	'LIVE_bullet_named': '%{name} felsorolás diagram',
	'LIVE_bullet_named_numbered': '%{name} felsorolás diagram (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Ezen a műszerfalon az adatokat biztosítja: ',
	'showFooterToggleButtonText': 'Lábléc megjelenítése',
	'showFooterSectionText': 'Lábléc'
});
